document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector('.navcollection-slider');
    const sliderItems = document.querySelectorAll('.navcollection-slider-item');
    const prevArrow = document.getElementById('prevArrow');
    const nextArrow = document.getElementById('nextArrow');

    if (!slider || !prevArrow || !nextArrow || !sliderItems.length) return

    const itemWidth = sliderItems[0].offsetWidth + 10;
    let visibleWidth, totalWidth, maxScrollPosition, currentScrollPosition = 0;
    let isTouching = false, startX = 0, currentX = 0;

    const updateDimensions = () => {
        const marginLeft = parseInt(window.getComputedStyle(slider).marginLeft, 10) || 0;
        visibleWidth = slider.offsetParent.offsetWidth - marginLeft;
        totalWidth = sliderItems.length * itemWidth;
        maxScrollPosition = Math.max(totalWidth - visibleWidth + 10, 0);

        const slidesFit = Math.floor(visibleWidth / itemWidth);
        const shouldCenter = sliderItems.length <= slidesFit && sliderItems.length <= 9;

        slider.classList.toggle('center', shouldCenter);
        slider.classList.toggle('with-margin', sliderItems.length > slidesFit);

        prevArrow.style.display = (sliderItems.length > slidesFit) ? 'flex' : 'none';
        nextArrow.style.display = (sliderItems.length > slidesFit) ? 'flex' : 'none';

        if (currentScrollPosition > maxScrollPosition) {
            currentScrollPosition = maxScrollPosition;
            updateSliderTransform();
        }
    };

    const updateSliderTransform = () => {
        slider.style.transform = `translateX(-${currentScrollPosition}px)`;
    };

    const setScrollPosition = (position) => {
        currentScrollPosition = Math.min(Math.max(position, 0), maxScrollPosition);
        updateSliderTransform();
    };

    prevArrow.addEventListener('click', () => setScrollPosition(currentScrollPosition - itemWidth));
    nextArrow.addEventListener('click', () => setScrollPosition(currentScrollPosition + itemWidth));

    slider.addEventListener('touchstart', (event) => {
        isTouching = true;
        startX = event.touches[0].clientX;
        currentX = currentScrollPosition;
    });

    slider.addEventListener('touchmove', (event) => {
        if (!isTouching) return;
        const deltaX = event.touches[0].clientX - startX;
        setScrollPosition(currentX - deltaX);
    });

    slider.addEventListener('touchend', () => {
        isTouching = false;
    });

    window.addEventListener('resize', updateDimensions);

    updateDimensions();
});
